import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BarChartOutlinedSvg from "@ant-design/icons-svg/es/asn/BarChartOutlined";
import AntdIcon from '../components/AntdIcon';
var BarChartOutlined = function BarChartOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BarChartOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BarChartOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BarChartOutlined';
}
export default RefIcon;